import * as Sentry from '@sentry/react';
import compareSettings from '~/settings/compareSettings';
export const cosineSimilarity = (a, b) => {
    if (a.length !== b.length)
        return 0;
    let sum = 0;
    for (let i = 0; i < a.length; i += 1) {
        sum += a[i] * b[i];
    }
    return sum;
};
export const getBestSimilarityCandidate = (anchorTags, classification) => {
    var _a;
    try {
        const { embedding } = classification;
        if (!(embedding === null || embedding === void 0 ? void 0 : embedding.length))
            return undefined;
        let bestAnchor;
        let bestScore = -Infinity;
        for (const anchor of anchorTags.values()) {
            if (anchor.category !== classification.category)
                continue;
            if (!((_a = anchor.embedding) === null || _a === void 0 ? void 0 : _a.length))
                continue;
            const score = cosineSimilarity(embedding, anchor.embedding);
            if (score > bestScore) {
                bestScore = score;
                bestAnchor = anchor;
            }
        }
        if (!bestAnchor)
            return undefined;
        return { anchorName: bestAnchor.name, score: bestScore };
    }
    catch (error) {
        console.error('Rule 7 similarity alignment failed; skipping similarity match', error);
        Sentry.captureException(error, {
            extra: { classificationName: classification === null || classification === void 0 ? void 0 : classification.name },
        });
        return undefined;
    }
};
export const getSimilarityMatchKey = (anchorTags, classification) => {
    const candidate = getBestSimilarityCandidate(anchorTags, classification);
    if (candidate && candidate.score >= compareSettings.similarityThreshold) {
        return {
            key: { rowKey: candidate.anchorName, tabKey: classification.name },
            score: candidate.score,
        };
    }
    return undefined;
};
